import EnvironmentUrlProvider from './EnvironmentUrlProvider'
export default EnvironmentUrlProvider
